/**
 * 通用导出组件
 */
import request from '@/utils/http';
import { $translate } from '@/utils/i18n';
// const EXPORT_API = '/api-lcp-report/report/task/export';

// 字符转数组
// function arrayStrToArray(obj) {
//     return Object.entries(obj).reduce((result, i) => {
//         if (i[1] !== '') {
//             result[i[0]] = `${i[1]}`.indexOf(',') > -1 ? i[1].split(',') : i[1];
//         }
//         return result;
//     }, {});
// }
const reportExport = {
    render() {
        return this.$scopedSlots.default({
            submit: this.submit
        });
    },
    data() {
        return {};
    },
    methods: {
        async submit(searchData) {
            let params = { ...searchData };
            Reflect.deleteProperty(params, 'pageSize');
            Reflect.deleteProperty(params, 'pageNo');
            Reflect.deleteProperty(params, 'EXPORT_API');
            const reportRes = await request.post(searchData.EXPORT_API, params);
            if (reportRes && reportRes.code === '0') {
                this.$root.$emit('loopGetNewFile', { // 触发顶层VDom监听的事件（调用文件列表组件内的轮询获取新下载文件函数）
                    id: reportRes.data.reportFileInfoId,
                    time: reportRes.timestamp
                });
                this.dropFile({
                    listId: 'file-list' // 文件列表图标的ID
                });
                this.$message.success($translate('lang.E3202101260001', { defaultText: '已发送导出请求,请稍后到右上角用户文件列表中下载' }));
            }
        },
        async dropFile(params) { // 文件投放动效
            const flyingFile = document.createElement('div');
            const fileList = document.getElementById(params.listId);
            this.createFlyingFile(flyingFile);
            await this.animateFile(flyingFile, fileList);
            await this.animateFileList(fileList);
        },
        createFlyingFile(flyingFile) { // 生成动画主体
            const icon = document.createElement('i');
            icon.className = 'el-icon-document';
            icon.style.color = '#555757';
            flyingFile.appendChild(icon);
            if (!this.$children.length) return;
            const { top: originTop, left: originLeft } = this.$children[0].$el.getBoundingClientRect();
            flyingFile.className = 'flying-file';
            flyingFile.style.position = 'absolute';
            flyingFile.style.zIndex = '100';
            flyingFile.style.width = '20px';
            flyingFile.style.height = '20px';
            flyingFile.style.top = `${originTop}px`;
            flyingFile.style.left = `${originLeft}px`;
            flyingFile.style.opacity = 0;
            document.getElementsByTagName('body')[0].appendChild(flyingFile);
        },
        animateFile(flyingFile, fileList) { // 绘制文件图标动画路径
            if (!fileList) return;
            return new Promise((resolve) => {
                const { top: targetTop, left: targetLeft } = fileList.getBoundingClientRect();
                // 设置移动的位移 以及 缩小
                flyingFile.style.transform = `translate3d(${targetLeft - parseFloat(flyingFile.style.left)}px, ${targetTop - parseFloat(flyingFile.style.top)}px, 0) scale(0.6, 0.6)`;
                // 增加贝塞尔曲线
                flyingFile.style.transition = 'transform 1s cubic-bezier(0.68, -0.55, 0.27, 0.55)';
                flyingFile.style.opacity = 1;
                setTimeout(() => { // 动画完成后消失
                    document.getElementsByTagName('body')[0].removeChild(flyingFile);
                    resolve();
                }, 1000);
            });
        },
        async animateFileList(fileList) { // 添加列表图标动画
            fileList.style.display = 'inline-block';
            fileList.style.transition = 'transform 0.15s linear';
            await this.timeoutSetter(0).then(() => {
                fileList.style.transform = 'scale(0.8, 0.8)';
            });
            await this.timeoutSetter().then(() => {
                fileList.style.transform = 'scale(1.1, 1.1)';
            });
            await this.timeoutSetter().then(() => {
                fileList.style.transform = 'scale(0.9, 0.9)';
            });
            await this.timeoutSetter().then(() => {
                fileList.style.transform = 'scale(1, 1)';
            });
            await this.timeoutSetter(0).then(() => { // 动画完成后清除样式
                fileList.style.display = '';
                fileList.style.transition = '';
                fileList.style.transform = '';
            });
        },
        timeoutSetter(time = 150) { // 定时器
            return new Promise((resolve) => {
                let timeout = setTimeout(() => {
                    clearTimeout(timeout);
                    timeout = null;
                    resolve();
                }, time);
            });
        }
    }
};

export default reportExport;